var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarenheit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7248 22C12.81 22 13.4496 21.3256 13.4496 20.1744V15.1744H18.8754C19.7778 15.1744 20.3489 14.6512 20.3489 13.7791C20.3489 12.9186 19.7664 12.3953 18.8754 12.3953H13.4496V7.90698H19.4351C20.3718 7.90698 21 7.36047 21 6.45349C21 5.54651 20.3832 5 19.4351 5H11.7248C10.6397 5 10 5.67442 10 6.82558V20.1744C10 21.3256 10.6397 22 11.7248 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5C8 5.88071 6.88071 7 5.5 7C4.11929 7 3 5.88071 3 4.5C3 3.11929 4.11929 2 5.5 2C6.88071 2 8 3.11929 8 4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarenheit);
export default __webpack_public_path__ + "static/media/farenheit.bdfe63bdb29803d87f80b84a81987e47.svg";
export { ForwardRef as ReactComponent };